// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"296":"ea88be26","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"296":"75e3e1ac8665607f6891","532":"39490eb9cedf186dbeed","678":"daea0078b86ab6353c55","883":"b02ce4ce7d3586f937be"}[chunkId] + ".js";
};